




































import masterdata from '@/services/masterdata';
import IbanErrorsDialog from '@/components/masterData/components/IbanErrorsDialog.vue';

export default {
    components: {
        'iban-errors': IbanErrorsDialog,
    },
    props: {
        value: String,
        validate: Boolean,
        formstyle: Object,
        pdfFile: Object,
    },
    watch: {
        validate(this: any, newVal: any, oldVal: any) {
            this.checkAndEmit();
        },
    },
    data(this: any): any {
        const checkIban = (rule: any, value: any, callback: any) => {
            if (this.Iban === '' || this.Iban == null) {
                callback(new Error(this.$t('masterDataFromRules.Required').toString()));
            }
            if (this.ibanchecked === 'danger') {
                callback(new Error(this.$t('masterDataFromRules.Iban').toString()));
            }
            callback();
        };
        const checkPDF = (rule : any, value: string, callback: any) => {
            if (this.pdf_file[0] == null || this.pdf_file.length === 0) {
                callback(new Error(this.$t('masterDataFromRules.Required').toString()));
            }
            callback();
        };
        return {
            rules: {
                Iban: [
                    { validator: checkIban, trigger: ['blur', 'change'] },
                ],
                fileUpload: [
                    { validator: checkPDF, trigger: ['blur', 'change'] },
                ],
            },
            ibanvalidation: {},
            ibanchecked: '',
            ibandialogVisible: false,
            pdf_file: [],
            Iban: '',
            form: {},
        };
    },
    computed: {
        computeiban: {
            get(this: any) {
                if (this.Iban != null && this.Iban !== '') {
                    return this.Iban;
                }
                return this.value;
            },
            set(this: any, newValue: String) {
                this.ibanchecked = '';
                this.Iban = newValue;
                this.$emit('input', this.Iban);
                this.$emit('reset');
            },
        },
        buttoncolor(this: any) {
            if (this.pdf_file.length !== 0 && this.pdf_file[0] != null) {
                return 'success';
            }
            return 'primary';
        },
    },
    methods: {
        async getIbanCheck(this: any) {
            if (this.Iban != null && this.Iban !== '') {
                const loading = this.$loading({ lock: true, text: 'Loading', background: 'rgba(0, 0, 0, 0.7)' });
                try {
                    this.ibanvalidation = await masterdata.getIbanCheck(this.Iban);
                } catch (error) {
                    masterdata.errorMessageAlert(this, error, loading, 'masterData.GetFailed', 'masterData.IBANCheck');
                    this.ibanchecked = 'warning';
                    return;
                }
                if (masterdata.isIbanCheckSuccses(this.ibanvalidation)) {
                    this.ibanchecked = 'success';
                } else {
                    this.ibanchecked = 'danger';
                    this.ibandialogVisible = true;
                }
                loading.close();
            }
        },
        handleFile() { },
        setNewFile(this: any, file: any, fileList: any) {
            this.pdf_file = fileList;
            this.$emit('file', this.pdf_file[0]);
        },
        clearPdfFileList(this: any, type: any) {
            this.$refs.upload1.clearFiles();
            this.pdf_file = [];
        },
        async checkAndEmit(this: any) {
            if (this.ibanchecked !== 'success') {
                await this.getIbanCheck();
            }
            this.$emit('input', this.Iban);
            this.$refs.form.validate((val: any) => {
                if (val && this.ibanchecked === 'success') {
                    this.$emit('ok');
                }
            });
        },
    },
    beforeMount(this: any) {
        this.Iban = this.value;
        if (this.pdfFile != null) this.pdf_file[0] = this.pdfFile;
    },
};
